import { NgModule, ModuleWithProviders } from '@angular/core';
import { CommonModule } from '@angular/common';
import { GoogleMap, GoogleMapsModule } from '@angular/google-maps';
import { AgmMapComponent } from './agm-map.component';
import { AgmMarkerComponent } from './agm-marker.component';
import { AgmCircleComponent } from './agm-circle.component';
//import {AgmInfoWindowComponent} from "./agm-info-window.component";
import { AgmPolygonComponent } from './agm-polygon.component';
//import {AgmKmlLayerComponent} from "./agm-kml-layer.component";
//import {AgmPolylinePointComponent} from "./agm-polyline-point.component";
//import {AgmPolylineComponent} from "./agm-polyline.component";

@NgModule({
  declarations: [
    AgmMapComponent,
    AgmMarkerComponent,
    AgmCircleComponent,
    //AgmInfoWindowComponent,
    AgmPolygonComponent,
    //AgmKmlLayerComponent,
    //AgmPolylinePointComponent,
    //AgmPolylineComponent
  ],
  imports: [CommonModule, GoogleMapsModule],
  exports: [
    AgmMapComponent,
    AgmMarkerComponent,
    AgmCircleComponent,
    //AgmInfoWindowComponent,
    AgmPolygonComponent,
    //AgmKmlLayerComponent,
    //AgmPolylinePointComponent,
    //AgmPolylineComponent
  ],
  providers: [GoogleMap],
})
export class AgmMapModule {
  static forRoot(config: {
    apiKey: string;
    libraries: string[];
  }): ModuleWithProviders<AgmMapModule> {
    return {
      ngModule: AgmMapModule,
      providers: [
        { provide: 'googleMapsApiKey', useValue: config.apiKey },
        { provide: 'googleMapsLibraries', useValue: config.libraries },
      ],
    };
  }
}
